import React, { useState } from "react";
import { observer } from "mobx-react";
import { ReactComponent as FileIcon } from "Assets/svg/linkedinTemplate/fileIcon.svg";
import { ReactComponent as RightArrowIcon } from "Assets/svg/linkedinTemplate/rightArrowIcon.svg";
import { ReactComponent as CloseIcon } from "Assets/svg/close-material.svg";
import { withRouter } from "react-router-dom";
import Button from "Components/common/Button";
import { linkedInTemplatePopupState } from "./LinkedInTemplatePopupState";
import { LinkedInTemplatesListLoading } from "./LinkedInTemplatesListLoading";
import { seqTemplatePopupState } from "./SequenePredefinedTemplate/SeqTemplatePopupState";
import Utils from "Utils/utils";

const LinkedInTemplatesListPopup = observer((props) => {
  const {
    showTemplatesListPopup,
    setShowTemplatesListPopup,
    setShowDetailsPopup,
    templates,
    templatesLoader,
    fetchLinkedInTemplates,
    applyLinkedInTemplate,
    applyTemplateLoader,
    selectedTemplate,
    setSelectedTemplate
  } = linkedInTemplatePopupState;

  React.useEffect(() => {
    if (showTemplatesListPopup) {
      fetchLinkedInTemplates();
    }
  }, [showTemplatesListPopup]);

  if (!showTemplatesListPopup) return null;

  const handleClose = () => {
    if (applyTemplateLoader) return;
    setShowTemplatesListPopup(false);
    seqTemplatePopupState.setAction("");
  };

  const handleBack = () => {
    if (applyTemplateLoader) return;
    if (seqTemplatePopupState.action === "selectTemplates") {
      seqTemplatePopupState.setSelectedTemplateType("");
      setShowTemplatesListPopup(false);
    } else {
      setShowTemplatesListPopup(false);
      seqTemplatePopupState.setAction("");
    }
  };

  const handleUseTemplate = () => {
    if (selectedTemplate && !applyTemplateLoader) {
      const folderId = Utils.getFolderDetails()?.folderId;
      applyLinkedInTemplate(selectedTemplate.id, folderId, props.history);
    }
  };

  return (
    <div className="linkedinTemplatesListPopupSection">
      <div className="card animated customzoomIn">
        <div className="popupHeader">
          <h2 className="title">LinkedIn Sequence Templates</h2>
          <CloseIcon
            className={`closeIcon ${applyTemplateLoader ? "disabled" : ""}`}
            onClick={handleClose}
          />
        </div>
        <div className="templatesListWrapper">
          <div className="listContainer">
            {templatesLoader ? (
              <LinkedInTemplatesListLoading />
            ) : templates.length > 0 ? (
              templates.map((template, index) => {
                const isSelected = selectedTemplate === template;
                return (
                  <div
                    key={template._id || template.id || template.name || index}
                    className={`templateItem ${isSelected ? "selected" : ""}`}
                    onClick={() => {
                      setSelectedTemplate(template);
                      setShowTemplatesListPopup(false);
                      setShowDetailsPopup(true, template);
                    }}
                  >
                    <FileIcon className="fileIcon" />
                    <div className="templateInfo">
                      <span className="linkedinTemplateName">
                        {template.name}
                      </span>
                      {template.description && (
                        <span className="linkedinTemplateDescription">
                          {template.description}
                        </span>
                      )}
                    </div>
                    <RightArrowIcon
                      className="arrowIcon"
                    />
                  </div>
                );
              })
            ) : (
              <div className="noTemplates">No templates found</div>
            )}
          </div>
        </div>
        <div className="popupFooter">
          <button
            className="backBtn"
            onClick={handleBack}
            disabled={applyTemplateLoader}
          >
            Back
          </button>
          <Button
            btnText={linkedInTemplatePopupState.targetSequenceId ? "Use Template" : "Create and Customize"}
            className={`useTemplateBtn ${applyTemplateLoader ? "loading" : ""}`}
            disabled={!selectedTemplate || templatesLoader || applyTemplateLoader}
            knobs={applyTemplateLoader}
            click={handleUseTemplate}
          />
        </div>
      </div>
      <div className="overlayMaskPopup" onClick={handleClose}></div>
    </div>
  );
});

export { LinkedInTemplatesListPopup };
export default withRouter(LinkedInTemplatesListPopup);
